import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const PartnerStrip = () => {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    api.get("/partners").then((r) => setPartners(r.data)).catch(() => {});
  }, []);

  if (partners.length === 0) return null;

  return (
    <section className="border-t border-black/10" style={{ background: "#EEF1F7" }} data-testid="partner-strip">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-10">
        <p className="text-xs tracking-[0.25em] uppercase mb-6" style={{ color: "var(--elsa-grey)" }}>
          Met de steun van onze partners
        </p>
        <div className="flex flex-wrap gap-x-8 gap-y-3">
          {partners.map((p) => (
            <a
              key={p.id}
              href={p.website || "#"}
              target="_blank"
              rel="noreferrer"
              data-testid={`partner-strip-link-${p.id}`}
              className="text-sm font-500 text-[#0B0B0C]/60 hover:text-[#0A3087] transition-colors"
            >
              {p.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
